import React from "react";
import "./erxPreviewContainerHeaderView.scss";
import close from "../../../../assets/close.svg";
import buttonArrow from "../../../../assets/buttonArrow.svg";

const ErxPreviewContainerHeaderView = (props) => {
  const { handleClose, handleCloseErx } = props;

  return (
    <div className="erx-preview-header-container">
      <img
        className="button-arrow"
        onClick={handleClose}
        src={buttonArrow}
        alt="#"
      />
      <div style={{ flex: "1" }}>
        <div className="erx-preview-header-heading">Prescription Preview</div>
        <div className="erx-preview-header-content">E-prescription 01</div>
      </div>
      <div className="erx-preview-header-close" onClick={handleCloseErx}>
        <img src={close} alt="" />
      </div>
    </div>
  );
};

export default ErxPreviewContainerHeaderView;
